import axios from "axios";

const url = process.env.REACT_APP_API_URL_REGISTER;
const urlFile = process.env.REACT_APP_API_URL_FILE;

export default class RegistrasiService {

    // ─────────────────────────────────────────────
    // BARU: Satu endpoint untuk seluruh proses registrasi
    // Menggantikan: registerTrader + registrasiUser + createTraderUPT
    //             + registrasiService + createTraderDokumen
    // ─────────────────────────────────────────────
    registerFull(payload) {
        return axios.post(url + '/register-full', payload);
    }

    // ─────────────────────────────────────────────
    // File upload tetap terpisah (ke file server)
    // ─────────────────────────────────────────────
    putDokumen(fileID, file) {
        const formData = new FormData();
        formData.append("file", file);
        return axios.post(urlFile + '/upload?nomorAju=' + fileID, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }

    // ─────────────────────────────────────────────
    // Lookup & validasi (dipakai sebelum submit)
    // ─────────────────────────────────────────────
    getTraderNPWP(npwp) {
        return axios.get(url + '/tradernpwp/' + npwp);
    }

    getUserName(userName) {
        return axios.get(url + '/username/' + userName);
    }

    getUser(kdTrader) {
        return axios.get(url + '/user/' + kdTrader);
    }

    getFolderName() {
        return axios.get(url + '/filefolder');
    }

    // ─────────────────────────────────────────────
    // Referensi data (propinsi, kota, UPT)
    // ─────────────────────────────────────────────
    getPropinsi() {
        return axios.get(url + '/propinsi');
    }

    // DIPERBAIKI: pakai endpoint yang filter by propinsi
    getKota(propinsi) {
        return axios.get(url + '/kota/' + propinsi);
    }

    getAllUpt() {
        return axios.get(url + '/allupt');
    }

    getUptById(kdUpt) {
        return axios.get(url + '/uptbyid/' + kdUpt);
    }

    // ─────────────────────────────────────────────
    // CRUD lain (dipakai di halaman lain, bukan registrasi)
    // ─────────────────────────────────────────────
    // getAllTrader() {
    //     return axios.get(url + '/traders');
    // }

    getAllTrader(kd_upt = null) {
        // Jika kd_upt ada, kirim sebagai query parameter
        const urlParams = kd_upt ? `?kd_unit=${kd_upt}` : '';
        return axios.get(url + '/newtraders' + urlParams);
    }

    getTrader(trade) {
        return axios.get(url + '/trader/' + trade);
    }

    maxTrader() {
        return axios.get(url + '/register-max');
    }

    updateTrader(trader, kdTrader) {
        return axios.patch(url + '/register/' + kdTrader, trader);
    }

    updateUser(user, kdUser) {
        return axios.patch(url + '/user/' + kdUser, user);
    }

    updateLayanan(layanan, kode) {
        return axios.patch(url + '/crlayanan/' + kode, layanan);
    }

    getKdUptByTrader(kdTrader) {
        return axios.get(url + '/gettraderupt/' + kdTrader);
    }

    updateTraderUPT(traderUpt, kdTrader, kdUpt) {
        return axios.patch(url + '/uptraderupt/' + kdTrader + '/' + kdUpt, traderUpt);
    }

    getLayanan(kdTrader) {
        return axios.get(url + '/getlayanan/' + kdTrader);
    }

    getDokumen(fileID, kdDok) {
        return axios.get(url + '/dokumen/' + fileID + '/' + kdDok);
    }

    getPegawai(nip) {
        return axios.get(url + '/pegawai/' + nip);
    }

    async updatePegawai(nip, data) {
        try {
            const response = await axios.put(url + `/pegawai/${nip}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: error.message };
        }
    }

    // ─────────────────────────────────────────────
    // Verifikasi (dipakai di halaman verifikasi)
    // ─────────────────────────────────────────────
    verifyApprove(kdTrader) {
        return axios.post(url + '/verify-approve/' + kdTrader);
    }

    verifyReject(kdTrader, alasan) {
        return axios.post(url + '/verify-reject/' + kdTrader, { alasan });
    }

    // ──────────────────────────────────────────────
    // Update dokumen (dipakai di halaman edit trader)
    // ─────────────────────────────────────────────
    updateDokumen(fileId, dokKode, dokPath) {
    return axios.patch(url + '/dokumen/' + fileId + '/' + dokKode, { DOK_PATH: dokPath });
}
}